<template>

	<div class="container main-content">
		<div class="row">
			<div class="col-12 col-sm-6">
				<div class="row mb-4">
					<div class="col-12 text-center mt-5">
						<h4 class="dark-highlight mb-5">Enter your receiving {{ pq.cryptoCurrency }} Address</h4>
						<input class="bitaddress form-control no-border-radius inline" 
							type="text" 
							ref="inputelem" 
							name="bitaddress" 
							v-model="in_address" 
							:class="{'is-invalid': hasError}"
							:disabled="isProcessing"
							>
						<small class="error" v-if="hasError">{{ errorMessage }}</small>
					</div>
				</div>
				<div class="row">
					<div class="col-12 text-center">
						<p class="mb-4"><small>By clicking next, you agree this is your personal wallet address.</small></p>
						<a href="#" id="address-input-next" class="btn next-btn" v-on:click.prevent="storeAddress" v-if="!isProcessing">NEXT</a>
						<a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">PLEASE WAIT... <i class="fas fa-circle-notch fa-spin"></i></a>
					</div>
				</div>
			</div>
			<div class="col-12 mt-5 pt-sm-0 offset-sm-1 col-sm-5 info-text">

				<template v-if="$gstate.getRecommendedWallet() !== undefined">
				<h5 class="mb-4">Need a wallet?</h5>
				<p class="mb-4">For a free, simple, secure and easy-to-setup wallet, we recommend <a target="_blank" :href="$gstate.getRecommendedWallet().url">{{ $gstate.getRecommendedWallet().name }}</a>.</p>
				</template>

				<div class="col-12 text-left p-4 panel-warning text-warning">
					<p>
						<strong>Attention</strong>
					</p>
					<ol class="pl-3">
						<li class="mb-3">Coins CANNOT be recovered if sent to the wrong address.  Please ensure you have entered the correct address.</li>
						<li>All purchases must go directly to you. Be cautious of others asking you to use this service to pay them directly as this may indicate a scam.  <a v-if="$gstate.isCoincurve()" target="_blank" :href="$gstate.getSiteURL() + '/security-bulletin'">Read more.</a></li>
					</ol>
					
				</div>
			</div>
		</div>
		
	</div>

</template>

<script>

import Bchaddr from 'bchaddrjs'
import validate from 'bitcoin-address-validation'
import Web3 from 'web3'
import WAValidator from 'wallet-address-validator'

import { eventBus } from './../main'

export default {
	data() {
		return {
			in_address: '',
			isProcessing: false,
			pq: this.$gstate.getFlowState(),
			hasError: false,
			errorMessage: '',
		}
	},
	computed: {
		
	},
	created(){
		eventBus.$on('nextScreen', this.storeAddress);
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.storeAddress);
	},
	methods: {
		storeAddress: function() {

			this.isProcessing = true;
			this.hasError = false;

			if (!this.in_address) {
				this.isProcessing = false;
				this.hasError = true;
				this.errorMessage = "Your " + this.pq.cryptoCurrency + " address is required.";
				return;
			}

			this.$gstate.log('Validating: ' + this.in_address + ', ' + this.pq.cryptoCurrency);

			var validationError = false;
			if(this.pq.cryptoCurrency == "BTC"){

				if(!validate(this.in_address)){
					validationError = true;
				}

			} else if (this.pq.cryptoCurrency == "BCH") {

				try {

					if(!Bchaddr.isCashAddress(this.in_address)){
						if(!Bchaddr.isLegacyAddress(this.in_address)){
							validationError = true;
						} else {
							if(!Bchaddr.isValidAddress(this.in_address)){
								validationError = true;
							}
						}
						
					}
				}
				catch(err) {
					validationError = true;
				}
			} else if (this.pq.cryptoCurrency == "LTCT"){
				
				// no validation for LTCT.  Only trim
				var str = this.in_address;
				this.in_address = str.trim();

			} else if (this.pq.cryptoCurrency == "LTC" || this.pq.cryptoCurrency == "ETH"){
				
				// LTC and ETH validation
				if(WAValidator.validate(this.in_address, this.pq.cryptoCurrency)){
					validationError = false;
				} else {
					validationError = true;
				}

			} else {
				validationError = true;
			}
			
			if(validationError){
				this.isProcessing = false;
				this.hasError = true;
				this.errorMessage = "This is not a valid " + this.pq.cryptoCurrency + " address.";
				return;
			}

			this.$gstate.log("validating address...");

			var urlstr = this.$gstate.getApiBaseURL() + '/cryptoaddress';
			this.axios.post(urlstr,{
				refId: this.$gstate.getRefId(),
				cryptoAddress: this.in_address,
			}, 
			this.$gstate.getAxiosHeaders()
			).then(response => {

					this.$gstate.log(response);
					this.isProcessing = false;
					
					//this.$gstate.saveRefId(response.data.refId);
					
					this.$gstate.saveCryptoAddress(this.in_address);
					this.$gstate.saveFlowStateAndProceed(response.data, this);

					/*
					if(this.$gstate.isProFlow()){

						// save buyer info
						var buyerInfo = {};
						buyerInfo.firstName = response.data.firstName;
						buyerInfo.lastName = response.data.lastName;
						this.$gstate.saveBuyerInfo(buyerInfo);

						// save question and answer
						var securityInfo = {};
						securityInfo.securityQuestion = response.data.securityQuestion;
						securityInfo.securityAnswer = response.data.securityAnswer;
						// always use vopay if pro flow
						this.$router.push('payment-etransfer-success');	
					} else {
						this.$router.push('buyer-info-input');
					}
					*/


				})
				.catch(error => {

					this.$gstate.log("error:");
					this.$gstate.log(error.response);
					
					this.isProcessing = false;
					this.hasError = true;
					this.errorMessage = error.response.data.error.msg;
				});
		}
	}
}
</script>
